import React from 'react';
import Moment from 'react-moment';
import { Link as NavLink } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { SvgIcon, Typography, IconButton } from '@material-ui/core';

import { ReactComponent as CalendarIcon } from '../../../images/Icons/calendar.svg';
import { ReactComponent as MapPinIcon } from '../../../images/Icons/map-pin.svg';
import { ReactComponent as TruckIcon } from '../../../images/Icons/truck.svg';
import { ReactComponent as ClockIcon } from '../../../images/Icons/clock.svg';
import { ReactComponent as EditIcon } from '../../../images/Icons/edit.svg';

import * as DateService from '../../../services/DateService';

const styles = theme => ({
  summary: {
    width: '450px',
    backgroundColor: '#f7ece2',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  field: {
    minWidth: '400px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    padding: theme.spacing(2, 2, 2, 2),
    '& > svg': {
      marginRight: theme.spacing(1)
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      minWidth: 'unset'
    }
  },
  iconButton: {
    padding: 0
  }
});

const Summary = withStyles(styles)(({ user, editable, classes }) => (
  <div className={classes.summary}>
    <div className={classes.field}>
      <SvgIcon>
        <CalendarIcon />
      </SvgIcon>
      <Typography>
        Usuaria desde{' '}
        <Moment date={user.creation_date} format="DD/MM/YYYY" locale="es" />
      </Typography>
    </div>
    <div className={classes.field}>
      <SvgIcon>
        <ClockIcon />
      </SvgIcon>
      <Typography>
        Última conexión hace {DateService.getDayDiffString(user.last_activity)}
      </Typography>
    </div>
    {user.selling_address && user.selling_address.region && (
      <div className={classes.field}>
        <SvgIcon>
          <MapPinIcon />
        </SvgIcon>
        <Typography style={{ flex: 1 }}>
          {user.selling_address.region.name},{' '}
          {user.selling_address.region.state &&
            user.selling_address.region.state.name}
        </Typography>
        {editable && (
          <IconButton
            classes={{ root: classes.iconButton }}
            component={NavLink}
            to="/configuracion/medios-de-envio"
          >
            <SvgIcon>
              <EditIcon />
            </SvgIcon>
          </IconButton>
        )}
      </div>
    )}
    {user.shipping_carrier && user.shipping_carrier.length > 0 && (
      <div className={classes.field}>
        <SvgIcon>
          <TruckIcon />
        </SvgIcon>
        <Typography style={{ flex: 1 }}>
          Envios por&nbsp;
          {user.shipping_carrier.length === 1
            ? user.shipping_carrier[0].name
            : [
                user.shipping_carrier
                  .slice(0, user.shipping_carrier.length - 1)
                  .map(carrier => carrier.name)
                  .join(', '),
                user.shipping_carrier[user.shipping_carrier.length - 1].name
              ].join(' y ')}
        </Typography>
        {editable && (
          <IconButton
            component={NavLink}
            to="/configuracion/medios-de-envio"
            classes={{ root: classes.iconButton }}
          >
            <SvgIcon>
              <EditIcon />
            </SvgIcon>
          </IconButton>
        )}
      </div>
    )}
  </div>
));

export default Summary;
